import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
  import router from "@/router";
  import store from "@/store";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'TermsHeader',
  setup(__props, { expose: __expose }) {
  __expose();

  const showLogin = computed(() => !store.state.user.accessToken);

  function onLogin() {
    router.push({ name: "SignIn" });
  }

const __returned__ = { showLogin, onLogin, computed, get router() { return router }, get store() { return store } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})